import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import {IRootState} from "../../../../store";
import DispatchProps from "../../../../utils/DispatchProps";
import ApiService from "../../../ApiService";
import Table, {TableColumn} from "../../../Table";
import {CommandBarButton} from "office-ui-fabric-react";
import JsonViewerCard from "../../../JsonViewerCard";
import {User} from "@microsoft/microsoft-graph-types";
import SchoolPageTitle from '../../../SchoolPageTitle';
import AdminSchoolMenu from '../../../AdminSchoolMenu';

export interface UserExploreResult
{
    user: User;
}
interface ExploreUserPageProps {
    tenantId: string;
    schoolCode: string;
    userId: string;
    apiService: ApiService;
}

interface ExploreUserPageState {
    userExploreResult?: UserExploreResult;
    showJson: boolean;
}

const USER_COLUMNS: TableColumn[] = [
    {title: "Id",propertyPath: "id",enableSort: false, flex: 1},
    {title: "Display Name",propertyPath: "displayName",enableSort: false, flex: 1},
    {title: "User Principal Name",propertyPath: "userPrincipalName",enableSort: false, flex: 1},
];

class ExploreUserPage extends Component<ExploreUserPageProps & DispatchProps, ExploreUserPageState> {
    static displayName = ExploreUserPage.name;

    constructor(props: ExploreUserPageProps & DispatchProps) {
        super(props);

        this.state = {
            userExploreResult: undefined,
            showJson: false
        }
    }

    async componentDidMount() {
        const userExploreResult = await this.props.apiService.exploreUser(this.props.tenantId,this.props.schoolCode,this.props.userId);

        this.setState({
            userExploreResult
        });
    }

    async componentDidUpdate(prevProps: Readonly<ExploreUserPageProps & DispatchProps>, prevState: any): Promise<void> {

    }

    render() {

        const jsonButton = (
            <CommandBarButton
                iconProps={{ iconName: "code" }}
                text={"Show all json"}
                onClick={() => {
                    this.setState({ showJson: true })
                }}
            />
        );

        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="Explore User" />

                <AdminSchoolMenu tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} />

                {this.state.showJson ?
                    <JsonViewerCard title={""} jsonObject={this.state.userExploreResult!}>
                        <CommandBarButton
                            iconProps={{ iconName: "cancel" }}
                            text={"Close"}
                            onClick={() => {
                                this.setState({ showJson: false })
                            }}
                        />
                    </JsonViewerCard> : null}
                
                <Table
                    title={"User"}
                    columns={USER_COLUMNS}
                    items={[this.state.userExploreResult!]}>
                    {jsonButton}
                </Table>
                
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState,ownProps: any): ExploreUserPageProps => {

        const tenantId = ownProps.match.params.tenantId;
        const schoolCode = ownProps.match.params.schoolCode;
        const userId = ownProps.match.params.userId;

        return {
            tenantId: tenantId,
            schoolCode: schoolCode,
            userId: userId,
            apiService: state.auth.apiService
        };
    }
)(ExploreUserPage)